import styled from 'styled-components';

export const FieldContainer = styled.div`
	width: 100%;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: flex-start;
	gap: 0.5rem;
	align-self: stretch;
`;

export const FieldWrapper = styled.div`
	width: 100%;
`;

export const PencilWrapper = styled.div`
	display: inline-block;
	border-radius: 50%;
	svg {
		display: block;
	}
	&:hover {
		background-color: ${(props) => props.theme.v2.color.neutral[300]};
		cursor: pointer;
	}
`;

export const TextHeading = styled.div<{ $shouldHover?: boolean }>`
	color: ${(props) => props.theme.v2.color.neutral[700]};
	font-size: 0.875rem;
	font-style: normal;
	font-weight: 400;
	line-height: 1.25rem;

	${(props) =>
		props.$shouldHover &&
		`
		&:hover {
			text-decoration: underline;
			color: ${props.theme.v3.colors.blue[6]};
		}
		cursor: pointer;
		transition: text-decoration 0.2s ease-in-out;
	`}
`;

export const TextValue = styled.div`
	color: ${(props) => props.theme.v2.color.neutral[1200]};
	font-size: 0.875rem;
	font-style: normal;
	font-weight: 400;
	line-height: 1.5rem;
	word-wrap: break-word;
	width: 100%;
`;
